import { FunctionComponent } from "react";
import { ToastContainer } from "react-toastify";
import EditProfileForm from "../../../components/EditProfileForm";
import ImageSideContainer from "../../../components/ImageSideContainer";
import Label from "../../../components/Label";

import "../../../styles/EditProfile/index.scss";

const EditProfile: FunctionComponent = ({}) => {
  return (
    <>
      <ToastContainer autoClose={1500} position={"bottom-left"} />
      <ImageSideContainer>
        <header className="signUp_header">
          <Label tag="h1">Editar perfil</Label>
        </header>
        <EditProfileForm />
      </ImageSideContainer>
    </>
  );
};

export default EditProfile;
